import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useContent } from "../context/ContentContext";

export const FAQ = () => {
  const { content } = useContent();
  const FAQS = content.faqs || [];
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-24 lg:py-36 max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-accent">// Intel</span>
          <h2 className="mt-5 font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl leading-[0.9]">
            Questions,<br />answered
          </h2>
        </div>
        <div className="lg:col-span-8 border-t border-white/10">
          {FAQS.map((f, i) => (
            <div key={i} data-testid={`faq-${i}`} className="border-b border-white/10">
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-6 py-7 text-left group"
              >
                <span className="font-display font-bold text-xl lg:text-2xl tracking-tight group-hover:text-accent transition-colors duration-300">{f.q}</span>
                <Plus size={22} className={`flex-shrink-0 text-white/40 transition-transform duration-400 ${open === i ? "rotate-45 text-accent" : ""}`} />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-7 font-body text-white/55 leading-relaxed max-w-2xl">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
